<template>
    <section v-if="show" class="h-screen">
        <div no-class="fixed inset-0 overflow-hidden">
            <div no-class="absolute inset-0 overflow-hidden">
                <div class="flex flex-wrap bg-blue-50">
                    <div class="flex flex-col w-full lg:w-9/12">
                        <div class="bg-blue-50 pb-28 stage-bg">
                            <header class="pb-10 pt-6">
                                <div class="mx-auto px-4 sm:px-6 lg:px-8">
                                    <div class="flex items-stretch">
                                        <div class="flex-1 self-center px-1">
                                            <h1
                                                class="text-2xl leading-9 font-bold text-blue-900 stage-text"
                                                no-click="streamCount()"
                                            >
                                                {{ meeting.title }}
                                            </h1>
                                            <h3
                                                class="text-xl font-bold text-blue-900 stage-text"
                                            >
                                                {{ meeting.date }} om
                                                {{ meeting.time }}
                                            </h3>
                                        </div>

                                        <div class="flex-initial self-end">
                                            <logo-nl
                                                height="h-24"
                                                class="h-24"
                                                v-if="!logo"
                                            ></logo-nl>
                                            <img
                                                :src="logo"
                                                class="h-24 w-auto"
                                                v-if="logo"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </header>
                        </div>

                        <main class="-mt-32">
                            <div
                                class="mx-auto pb-12 px-4 sm:px-6 lg:px-8"
                                v-if="videoWindows"
                            >
                                <div
                                    v-if="room.type == 'ivs'"
                                    class="embed-container bg-white rounded-lg shadow px-5 py-6 sm:px-6 w-full items-center"
                                >
                                    <svg
                                        v-if="!room.embed"
                                        class="flex animate-spin h-12 w-12 mx-auto mt-8 text-gray items-center"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            class="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            stroke-width="4"
                                        />
                                        <path
                                            class="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        />
                                    </svg>
                                    <ivs-embed
                                        v-if="room.embed && embedIVS"
                                        :playback_url="room.embed"
                                        allow_fullscreen="no"
                                    ></ivs-embed>
                                </div>

                                <div
                                    v-if="room.type == 'embed'"
                                    class="embed-container bg-gray-50 rounded-lg shadow-xl px-5 py-6 sm:px-6 w-full items-center"
                                >
                                    <svg
                                        v-if="!room.embed"
                                        class="flex animate-spin h-12 w-12 mx-auto mt-8 text-gray items-center"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            class="opacity-25"
                                            cx="12"
                                            cy="12"
                                            r="10"
                                            stroke="currentColor"
                                            stroke-width="4"
                                        />
                                        <path
                                            class="opacity-75"
                                            fill="currentColor"
                                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                        />
                                    </svg>
                                    <span v-html="room.embed"></span>
                                </div>

                                <div
                                    class="embed-container bg-gray-50 rounded-lg shadow-xl px-5 py-6 sm:px-6 w-full items-center"
                                    v-if="room.type == 'broadcast'"
                                >
                                    <session
                                        v-if="apiKey && token"
                                        :key="system_role"
                                        :user_name="user_name"
                                        :apiKey="apiKey"
                                        :sessionId="sessionId"
                                        :token="
                                            typeOfToken == 'viewer'
                                                ? viewToken
                                                : token
                                        "
                                        :publishToken="token"
                                        :viewToken="viewToken"
                                        :output="output"
                                        :role="typeOfToken"
                                        :system_role="system_role"
                                    ></session>
                                </div>

                                <vonage-controller
                                    v-if="
                                        meeting &&
                                        room.type == 'broadcast' &&
                                        vonageToolbar
                                    "
                                    class="mt-4"
                                    :streamers="streamers"
                                    :system_role="system_role"
                                    :meeting="meeting.hash"
                                    :is_started="meeting.is_started"
                                ></vonage-controller>

                                <!-- /End replace -->
                            </div>
                        </main>
                    </div>
                    <sidebar
                        v-if="room.name"
                        :pusher="room.slug"
                        :room="room.slug"
                        :tab_poll="room.slug"
                        :tab_info="room.slug"
                        :tab_document="meeting.hash"
                        :meeting="meeting.hash"
                        :backstage="backstage"
                    ></sidebar>
                </div>
            </div>
        </div>
    </section>
</template>
<style>
.embed-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.OT_subscriber {
    float: right;
}
.OT_publisher {
    float: left;
}
.chrome-only {
    visibility: hidden;
}
@media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    .chrome-only {
        visibility: visible;
    }
}
@supports (-ms-ime-align: auto) {
    .chrome-only {
        visibility: visible;
    }
}
.OT_archiving-status {
    display: none !important;
}
</style>

<script>
export default {
    mounted() {
        Eventing.fire("checkAuthStatus");
        this.getRoom(this.$route.params.slug);

        try {
            if (window.screen.width < 650 || window.innerWidth < 550) {
                // this.videoWindows = false;
            }
        } catch (error) {}

        try {
            if (
                document.head.querySelector('meta[name="livepresent"]')
                    .content == "yes"
            ) {
                this.videoWindows = false;
            }
        } catch (error) {}

        Eventing.listen(
            "onlineUsers",
            (onlineUsers) => (this.nowOnline = parseInt(onlineUsers)),
            // onlineUsers => alert(parseInt(onlineUsers))
        );

        Eventing.listen(
            "hideVonageToolbar",
            () => (this.vonageToolbar = false),
        );
        Eventing.listen(
            "publishStreamers",
            (streamers) => (this.streamers = streamers),
        );

        Eventing.listen("publishRequest", (source) => this.joinMeeting(source));

        Eventing.listen(
            "removeFromSessionOT",
            () => this.closePublisher(),
            // onlineUsers => alert(parseInt(onlineUsers))
        );
        this.apiKey = process.env.MIX_TOK_API;

        Eventing.listen("invitedForMeeting", () => this.handleInvite());
        Eventing.listen("startedStreaming", () => this.checkStreamExceeded());
    },
    data() {
        return {
            videoWindows: true,
            show: false,
            room: {
                embed: null,
                limit: 0,
                has_broadcast_limit: true,
            },
            backstage: false,
            broadcast_limit: 2,
            meeting: {},
            session: null,
            apiKey: null,
            token: null,
            sessionId: null,
            user_name: null,
            tenant: null,
            role: null,
            output: "webcam",
            mayPublish: false,
            nowOnline: -1,
            viewToken: null,
            isPublishing: false,
            isLoaded: false,
            embedIVS: false,
            stoppingMeeting: false,
            streamers: null,
            vonageToolbar: false,
            system_role: "subscriber",
            slug: null,
            logo: null,
        };
    },
    created() {
        this.output = this.$route.query.source;
        Eventing.fire("forcedSoftUnpublish");
        this.slug = this.$route.params.slug;
    },
    beforeMount() {
        console.info("beforeMount");
        Eventing.fire("forcedSoftUnpublish");
        this.show = false;
    },
    beforeUnmount() {
        console.info("beforeUnmount");
        this.show = false;
        Eventing.fire("forcedSoftUnpublish");
        console.log("this.$route.params.slug: " + this.slug);
        this.getRoom(this.slug);
        if (this.system_role != "subscriber") {
            Eventing.fire("stopSession");
        }
        // window.location.reload();
    },
    methods: {
        handleInvite() {
            let self = this;
            self.getRoom(self.slug);
        },
        closePublisher() {
            this.mayPublish = false;

            if (
                this.system_role != "moderator" &&
                this.system_role != "publisher"
            ) {
                this.vonageToolbar = false;
            } else {
                // setTimeout(() => {
                //     window.location.reload();
                // }, 200);
            }
            this.vonageToolbar = false;
            // this.show = false;
            // this.getRoom();
        },
        setLogo() {
            try {
                this.logo =
                    document.head.querySelector('meta[name="logo"]')?.content;
            } catch (error) {}
        },
        joinMeeting(source) {
            let self = this;
            axios
                .get("/api/rooms/" + this.room.slug)
                .then((response) => {
                    console.info("streamCount");
                    console.info(response.data);
                    if (response.data < parseInt(self.broadcast_limit)) {
                        // setTimeout(() => {
                        self.mayPublish = true;
                        Eventing.fire("changeOfOpenTokToken", source);
                        Eventing.fire("resetPublishSource", source);
                        // self.room.type = "broadcast";
                        // }, 100);
                    } else {
                        Eventing.fire("notify", {
                            title: self.t(
                                "room.connect-failure",
                                "Verbinden als uitzender mislukt",
                            ),
                            message: self.t(
                                "room.limit-exceeded",
                                "Limiet van aantal toegestane uitzenders is :value en deze is bereikt",
                                self.broadcast_limit,
                            ),
                            type: "error",
                            position: "center",
                        });
                    }
                })
                .catch((error) => {
                    if (error.response) {
                    }
                });
        },
        stopMeeting() {
            this.stoppingMeeting = true;
        },
        getTrans(text) {
            let self = this;
            if (text == "tts.babbelbox.join") {
                return self.t("tts.babbelbox.join", {
                    available: self.room.limit - self.nowOnlineInRoom,
                    limit: self.room.limit,
                });
            }
            return self.t(text);
        },
        startShare(output) {
            this.$router.replace({
                name: "backstage",
                params: { slug: this.route.slug },
                query: { source: output },
            });
        },
        getRoom(slug) {
            console.log("getRoom");
            var self = this;
            axios
                .get("/api/meetings/" + slug)
                .then((response) => {
                    console.info(response.data.data);
                    self.meeting = response.data.data;
                    self.room = response.data.data.room;
                    self.broadcast_limit = parseInt(
                        response.data.broadcast_limit,
                    );
                    self.token = response.data.token;
                    self.viewToken = response.data.view_token;
                    self.viewToken = response.data.token;
                    if (!response.data.view_token) {
                        self.viewToken = response.data.token;
                    }
                    self.sessionId = response.data.data.room.session_id;
                    self.user_name = response.data.user_name;
                    self.role = response.data.role;

                    self.backstage = response.data.backstage;

                    if (!self.show) {
                        self.show = true;
                    }
                    self.system_role = response.data.system_role;
                    if (self.system_role == "moderator") {
                        self.vonageToolbar = true;
                    } else if (self.system_role == "publisher") {
                        self.vonageToolbar = true;
                    } else {
                        self.vonageToolbar = false;
                    }
                    if (self.user_name == "Moderator!") {
                        // self.vonageToolbar = true;
                    } else {
                    }
                    self.setLogo();

                    if (self.room.type == "ivs") {
                        self.room.embed =
                            self.room.embed + "?token=" + self.token;

                        this.embedIVS = true;

                        setTimeout(function () {
                            Eventing.fire("start_ivs_stream");
                        }, 500);
                        // this.embedIVS = true;
                    }
                })
                .catch((error) => {
                    if (error.response) {
                    }
                });
        },
        errorHandler(err) {
            alert(err.message);
        },
        streamCount() {
            let self = this;
            axios
                .get("/api/rooms/" + this.room.slug)
                .then((response) => {
                    Eventing.fire("notify", {
                        title: "Status",
                        message: "Online: " + response.data + " streams",
                        type: "success",
                    });
                })
                .catch((error) => {
                    if (error.response) {
                    }
                });
        },
        checkStreamExceeded() {
            let self = this;
            axios
                .get("/api/rooms/" + this.room.slug)
                .then((response) => {
                    if (response.data > self.broadcast_limit) {
                        Eventing.fire("notify", {
                            title: "Error",
                            message: "Limit exceeded",
                            type: "error",
                        });
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    }
                })
                .catch((error) => {
                    if (error.response) {
                    }
                });
        },
    },
    watch: {
        embedIVS: function (val) {
            if (val == true) {
                setTimeout(function () {
                    // Eventing.fire("start_ivs_stream");
                }, 300);
            }
            this.embedIVS = val;
        },
    },
    computed: {
        typeOfToken() {
            return this.mayPublish ? "publisher" : "viewer";
        },
    },
};
</script>
